import styled from 'styled-components'

import { Colors, FontSize } from '~/styles'
import { Edit, Save, Cancel } from '@material-ui/icons'

const Container = styled.div`
  padding: 20px;
  height: 680px;
  padding-top: 5px;
  background-color: ${Colors.backgroundColor};
`

const AddItemWrapper = styled.div`
  display: flex;
  cursor: ${(p) => (p.disable ? 'not-allowed' : 'pointer')};
  align-items: center;
  color: ${Colors.softBlue};
`

const TopContent = styled.div`
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  justify-content: space-between;
`

const TopContentCargo = styled.div`
  display: flex;
  margin-top: -10px;
  margin-bottom: 10px;
  justify-content: space-between;
`

const Title = styled.p`
  font-weight: 600;
  font-size: ${FontSize.large};
`

const SubTitle = styled.p`
  font-weight: 500;
  color: ${Colors.grey};
  font-size: ${FontSize.medium};
  margin: 0;
`

const ContractText = styled.p`
  font-weight: 500;
  color: ${Colors.grey};
  font-size: ${FontSize.medium};
`

const ContractTextSpan = styled.span`
  color: ${Colors.grey};
  font-size: ${FontSize.mediumLarge};
`

const WrapperButton = styled.div`
    display: flex;
    cursor: pointer;
`

const IconButton = styled.img`
    width: 1em;
    height: 1em;
    flex-shrink: 0;
    user-select: none;
    font-size: 1.5rem;
    fill: currentColor;
    margin-right: 3px;
    `
const UploaderWrapper = styled.div`
    display: flex;
    cursor: pointer;
    margin-right: 25px;
    align-items: center;
    color: ${Colors.newGreen};
  `
const TextFieldContainer = styled.div`
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content:center;
`

const IconContainer = styled.div`
  width: 22px;
  margin-right: 10px;
  cursor: ${(p) => (p.disable ? 'default' : 'pointer')};
  color: ${(p) => (p.disable ? Colors.grey : Colors.softBlue)};
`

const CancelIcon = styled(Cancel)`
  color: ${(p) => (p.disable ? Colors.grey : Colors.red)};
`

const EditIcon = styled(Edit)`
  color: ${(p) => (p.disable ? Colors.grey : Colors.newGreen)};
`

const SaveIcon = styled(Save)`
  color: ${(p) => (p.disable ? Colors.grey : p.status ? Colors.hintGrey : Colors.softBlue)};
`

const EquipmentTitle = styled.p`
  font-weight: 600;
  margin-block-end: 5px;
  margin-block-start: 5px;
  font-size: ${FontSize.large};
`

const EquipmentContractText = styled.p`
  font-weight: 500;
  color: ${Colors.grey};
  margin-block-end: 5px;
  margin-block-start: 5px;
  font-size: ${FontSize.large}
  font-size: ${FontSize.medium};
`

const EquipmentWrapper = styled.div`
  margin-top: 10px;
`

const WMPanel = styled.div`
  margin-bottom: 14px;
  padding: 16px;
  border: 1px solid ${Colors.wrapGray};
  border-radius: 8px;
  background: ${Colors.white};
`

const WMPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`

const WMPanelTitle = styled.p`
  font-weight: 600;
  margin: 0;
  font-size: ${FontSize.mediumLarge};
`

const WMPanelBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 768px) {
    gap: 10px;
  }
`

const WMFieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const WMSearchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  flex-wrap: wrap;
  width: fit-content;
  max-width: 100%;
`

const WMSearchInput = styled.div`
  flex: 0 0 auto;
  min-width: 0;
`

const WMDateFilters = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
`

const WMResultsWrapper = styled.div`
  margin-top: 4px;
  max-height: 320px;
  overflow: auto;
`

const WMResultsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
`

const WMResultsHead = styled.thead`
  background: rgb(221, 234, 255);
`

const WMResultsHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  font-size: ${FontSize.medium}px;
  white-space: nowrap;
  background: rgb(221, 234, 255);
  color: rgb(51, 51, 51);
  font-weight: 500;
  position: sticky;
  top: 0;
  z-index: 2;
`

const WMResultsCell = styled.td`
  padding: 10px;
  border-top: 1px solid ${Colors.wrapGray};
  font-size: ${FontSize.medium}px;
  white-space: nowrap;
`

const WMActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid ${Colors.softBlue};
  border-radius: 50%;
  background: ${Colors.white};
  color: ${Colors.softBlue};
  cursor: pointer;
`

const WMEmptyState = styled.div`
  padding: 18px 12px;
  color: ${Colors.grey};
  font-size: ${FontSize.medium}px;
`

const EquipmentTopLeftWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`

export default {
  Title,
  SubTitle,
  EditIcon,
  SaveIcon,
  Container,
  CancelIcon,
  TopContent,
  IconButton,
  ContractText,
  WrapperButton,
  IconContainer,
  AddItemWrapper,
  EquipmentTitle,
  TopContentCargo,
  UploaderWrapper,
  ContractTextSpan,
  EquipmentWrapper,
  TextFieldContainer,
  EquipmentContractText,
  EquipmentTopLeftWrapper,
  WMPanel,
  WMPanelHeader,
  WMPanelTitle,
  WMPanelBody,
  WMFieldGroup,
  WMSearchRow,
  WMSearchInput,
  WMDateFilters,
  WMResultsWrapper,
  WMResultsTable,
  WMResultsHead,
  WMResultsHeaderCell,
  WMResultsCell,
  WMActionButton,
  WMEmptyState
}